/* eslint-disable operator-linebreak */
import { NORTHSPYRE_TIER_TYPES } from 'bricks/constants';
import useAuthContext from 'contexts/AuthContext';
import { useGetOrganizationLicenses } from 'hooks/useGetOrganizationLicenses';
import useGetActiveProjectsByLicenseTier from 'hooks/useGetActiveProjectsByLicenseTier';

export const useOrganizationAccess = () => {
    const { selectedOrganizationId } = useAuthContext();

    const {
        data: licenses,
        isLoading: isLoadingLicenses,
        error: errorLicenses,
    } = useGetOrganizationLicenses(selectedOrganizationId!, {
        enabled: Boolean(selectedOrganizationId),
    });

    const {
        data: activeProjects,
        isLoading: isLoadingActiveProjects,
        error: errorActiveProjects,
    } = useGetActiveProjectsByLicenseTier(selectedOrganizationId!, {
        enabled: Boolean(selectedOrganizationId),
    });

    const hasCoreAccess =
        licenses &&
        (!!licenses[NORTHSPYRE_TIER_TYPES.NORTHSPYRE_PLAN].length ||
            !!licenses[NORTHSPYRE_TIER_TYPES.NORTHSPYRE_PLAN_PLUS].length ||
            !!licenses[NORTHSPYRE_TIER_TYPES.NORTHSPYRE_PRO].length ||
            !!licenses[NORTHSPYRE_TIER_TYPES.NORTHSPYRE_ENTERPRISE].length ||
            !!licenses[NORTHSPYRE_TIER_TYPES.NORTHSPYRE_HISTORICAL_DATA].length);

    const hasEnterpriseLicense = !!licenses?.[NORTHSPYRE_TIER_TYPES.NORTHSPYRE_ENTERPRISE].length;

    const hasActiveEnterpriseProjects = activeProjects?.[NORTHSPYRE_TIER_TYPES.NORTHSPYRE_ENTERPRISE] &&
        activeProjects?.[NORTHSPYRE_TIER_TYPES.NORTHSPYRE_ENTERPRISE] > 0;
    const hasActiveProProjects = activeProjects?.[NORTHSPYRE_TIER_TYPES.NORTHSPYRE_PRO] && activeProjects?.[NORTHSPYRE_TIER_TYPES.NORTHSPYRE_PRO] > 0;
    const hasActivePlanProjects = activeProjects?.[NORTHSPYRE_TIER_TYPES.NORTHSPYRE_PLAN] && activeProjects?.[NORTHSPYRE_TIER_TYPES.NORTHSPYRE_PLAN] > 0;
    const hasActivePlanPlusProjects = activeProjects?.[NORTHSPYRE_TIER_TYPES.NORTHSPYRE_PLAN_PLUS] &&
        activeProjects?.[NORTHSPYRE_TIER_TYPES.NORTHSPYRE_PLAN_PLUS] > 0;
    const hasActiveLiteProjects = activeProjects?.[NORTHSPYRE_TIER_TYPES.NORTHSPYRE_LITE] && activeProjects?.[NORTHSPYRE_TIER_TYPES.NORTHSPYRE_LITE] > 0;

    const isLoading = isLoadingLicenses || isLoadingActiveProjects;

    const error = errorLicenses || errorActiveProjects;

    return {
        hasCoreAccess,
        hasEnterpriseLicense,
        hasActiveEnterpriseProjects,
        hasActiveProProjects,
        hasActivePlanProjects,
        hasActivePlanPlusProjects,
        hasActiveLiteProjects,
        isLoading,
        error,
    };
};
